<template>
  <path
    d="M3.06152 3L9.13259 9.07106L3.06152 15.1421"
    stroke="#ffffff"
    stroke-width="2"
    fill="transparent"
  />
  <path
    d="M15.0811 3L9.00999 9.07106L15.0811 15.1421"
    stroke="#ffffff"
    stroke-width="2"
    fill="transparent"
  />
</template>
